// components/SearchResultInfo.js
import React from 'react';

const SearchResultInfo = ({ totalResults = 0, searchValue = "" }) => {
  if (!searchValue || totalResults === 0) return null;
  return (
	<div className="mt-2 text-lg font-bold" role="status" aria-live="polite" aria-atomic="true">
	  Search Criteria: {`'${searchValue}' (${totalResults} ${totalResults > 1 ? 'records found' : 'record found'}) `}
	</div>
  );
};

export default SearchResultInfo;
